// extracted by mini-css-extract-plugin
export default {"select_copy_icon":"xivl8Rw9eAsXw2vm0GW2","advice_content":"p6A8qQWR0aMRzqbFySMH"};